




















































import Vue from 'vue'
import { SnackbarStateEnum } from '@/types/enums'
import { FETCH_EMAIL_TEMPLATE_LIST, SAVE_EMAIL_TEMPLATE } from '@/store/action-types'
import { EmailTemplate } from '@/model/settings/EmailTemplate'

interface ComponentData {
  subject: string
  body: string
  selectedTemplate: EmailTemplate | undefined
  emailTemplateList: any[] //Array<EmailTemplate>
  specialWords: Array<string>

  showSnackbar: boolean
  messageSnackbar: string
  snackbarState: number
  loading: boolean
}

export default Vue.extend({
  name: 'EmailDefaultTextPage',

  components: {},

  props: {},

  data (): ComponentData {
    return {
      subject: '',
      body: '',
      selectedTemplate: undefined,
      emailTemplateList: [],
      specialWords: [
        ' #Anrede# - Anrede des Empfängers (z.B. Guten Tag #Anrede# ... => Guten Tag Frau ... )',
        ' #Vorname# - Vorname des Empfängers (z.B. Hallo #Vorname# => Hallo Maria)',
        ' #Name# - Name des Empfängers (z.B. Guten Tag #Anrede# #Name# => Guten Tag Frau Müller)',
        ' #Anhang# -  Bezeichnung des Anhangs (z.B. im Betreff: #Anhang# von #Vorname# => Monatsplan von Maria)'
      ],

      showSnackbar: false,
      messageSnackbar: '',
      snackbarState: 0,
      loading: false
    }
  },

  computed: {
    snackbarColor (): boolean {
      return this.snackbarState === SnackbarStateEnum.Success
    },
  },

  watch: {},

  methods: {
    isSelectedTemplate (item:EmailTemplate): any {
      if(this.selectedTemplate && this.selectedTemplate.id === item.id) {
        return {borderColor: 'black'}
      } else {
        return {}
      }

    },

    onEmailTemplateClick (item: EmailTemplate): void {
      this.subject = item.subject
      this.body = item.body
      this.selectedTemplate = item
    },

    async onSaveButtonClick (): Promise<void> {
      //@ts-ignore
      if(this.$refs.form.validate()) {
        let payload: EmailTemplate
        if (this.selectedTemplate) {
          payload = EmailTemplate.create(
            this.selectedTemplate.id,
            this.subject,
            this.body,
            this.selectedTemplate.templateType)
        } else {
          payload = EmailTemplate.create(
            1,
            this.subject,
            this.body,
            1)
        }
        try {
          this.loading = true
          const response: boolean = await this.$store.dispatch(SAVE_EMAIL_TEMPLATE, payload)
          this.loading = false
          if(response) {
            this.snackbarState = 1
            this.messageSnackbar = this.$t('success.dataHaveBeenSaved').toString()
            this.showSnackbar = true
            this.fetchEmailTemplateList()
          } else {
            this.loading = false
            this.snackbarState = 0
            this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
            this.showSnackbar = true
          }
        } catch (e) {
          this.snackbarState = 0
          this.messageSnackbar = this.$t('errors.dataCouldNotBeSaved').toString()
          this.showSnackbar = true
        }
      }
    },

    async fetchEmailTemplateList (): Promise<void> {
      this.emailTemplateList = []
      const emailTemplateListResponse: Array<EmailTemplate> = await this.$store.dispatch(FETCH_EMAIL_TEMPLATE_LIST)
      let id: number = 0
      emailTemplateListResponse.forEach((item: EmailTemplate) => {
        if(item.groupId) {
          const foundTemplateGroup: any | undefined = this.emailTemplateList.find((i: any) => i.groupId === item.groupId)
          if(foundTemplateGroup) {
            foundTemplateGroup.template.push(item)
          } else {
            this.emailTemplateList.push(
                {id: id, groupId: item.groupId, groupName: item.groupName, template: [item]}
            )
          }
        } else {
          this.emailTemplateList.push(
              {id: id, groupId: undefined, groupName: '', template: [item]}
          )
        }

        id++
      })
    }

  },

  async mounted () {
    this.fetchEmailTemplateList()
  }

})
